import { SVGProps, useMemo } from 'react';

import { truncateText } from './truncateText';

type TextElementPropsSubset = Omit<
  SVGProps<SVGTextElement>,
  'children' | 'fontSize'
>;

export type TextProps = TextElementPropsSubset & {
  children: string;
  x: number;
  y: number;
  maxWidth?: number;
  maxHeight?: number;
  fontSize?: number;
};

export const Text = ({
  children,
  fontSize = 16,
  maxWidth = Infinity,
  maxHeight = Infinity,
  fontWeight = 580,
  x,
  y,
  ...textElementPropsSubset
}: TextProps): JSX.Element => {
  const displayText = useMemo(() => {
    if (maxWidth === Infinity && maxHeight === Infinity) return children;
    return truncateText(children, maxWidth, maxHeight, fontSize, fontWeight);
  }, [children, fontSize, fontWeight, maxHeight, maxWidth]);

  return (
    <text x={x} y={y} fontSize={fontSize} {...textElementPropsSubset}>
      {displayText}
    </text>
  );
};
